import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["phase", "singleCount", "quantityInput", "earlySamples", "earlySampleInput", "fallPlots", "fallPlotRows"]
  static values = { phase: String, fallCounts: Object, existingStems: Object }

  connect() {
    this.update()
  }

  update() {
    const earlySelected = this.currentPhase() === "early"
    const fallSelected = this.currentPhase() === "fall"

    this.singleCountTargets.forEach((element) => {
      element.classList.toggle("d-none", earlySelected || fallSelected)
    })
    this.quantityInputTargets.forEach((input) => {
      input.disabled = earlySelected || fallSelected
      input.required = !earlySelected && !fallSelected
    })
    this.earlySamplesTargets.forEach((element) => {
      element.classList.toggle("d-none", !earlySelected)
    })
    this.earlySampleInputTargets.forEach((input) => {
      input.disabled = !earlySelected
      input.required = earlySelected
    })

    this.fallPlotsTargets.forEach((element) => element.classList.toggle("d-none", !fallSelected))
    if (fallSelected && this.hasFallPlotRowsTarget) this.renderFallPlots()
  }

  renderFallPlots() {
    const plan = this.fallCountsValue[this.seasonYear()]
    if (!plan) {
      this.fallPlotRowsTarget.replaceChildren()
      return
    }

    this.fallPlotRowsTarget.replaceChildren(...Array.from({ length: plan.plots }, (_, index) => {
      const plotNumber = index + 1
      const row = document.createElement("tr")
      const value = this.existingStemsValue[plotNumber] ?? this.existingStemsValue[String(plotNumber)] ?? ""
      const plotCell = document.createElement("th")
      plotCell.scope = "row"
      plotCell.textContent = plotNumber
      const stepsCell = document.createElement("td")
      stepsCell.textContent = Number(plan.steps_per_plot).toFixed(2)
      const stemsCell = document.createElement("td")
      const input = document.createElement("input")
      input.className = "form-control form-control-lg"
      input.type = "number"
      input.min = "0"
      input.step = "1"
      input.inputMode = "numeric"
      input.required = true
      input.name = `inventory_count[fall_plot_stems][${plotNumber}]`
      input.value = value
      stemsCell.append(input)
      row.append(plotCell, stepsCell, stemsCell)
      return row
    }))
  }

  seasonYear() {
    const input = this.element.querySelector("[name='inventory_count[season_year]']")
    return input?.value
  }

  currentPhase() {
    if (this.hasPhaseTarget) return this.phaseTarget.value
    return this.phaseValue
  }
}
